module.exports = __webpack_public_path__ + "img/BI_3.7b185fc2.png";